import update from 'immutability-helper';
import { SignerStatus } from '../../common/constants';
import { ActionTypes } from '../actions';
import type { ISignatureSettings } from '../types';

interface IPendingBlockInfo {
  documentId: string;
  pageNumber: number;
  blockId: string;
}

export interface IModalState {
  signatureSettings?: ISignatureSettings;
  showSignatureModal: boolean;
  termsAccepted: boolean;
  signatureAccepted: boolean;
  alreadySigned: boolean;
  pendingBlockInfo?: IPendingBlockInfo;
  showExitSigningModal: boolean;
  getBlockValueFromSettings?: boolean;
  signerPhoneNumber?: {
    phoneNumber: string;
    email: string;
    signerId: string;
  };
}

const initialModalState: IModalState = {
  signatureSettings: undefined,
  showSignatureModal: false,
  termsAccepted: false,
  signatureAccepted: false,
  alreadySigned: false,
  pendingBlockInfo: undefined,
  showExitSigningModal: false,
  getBlockValueFromSettings: false,
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const modalReducer = (state: IModalState = initialModalState, action: any): IModalState => {
  switch (action.type) {
    case ActionTypes.FETCH_ENVELOPE_DONE: {
      const envelope = action.payload;
      if (envelope.signer.signingStatus === SignerStatus.COMPLETE) {
        return {
          ...state,
          alreadySigned: true,
          termsAccepted: true,
        };
      }
      return state;
    }
    case ActionTypes.SHOW_SIGNATURE_MODAL: {
      return update(state, {
        showSignatureModal: { $set: true },
        pendingBlockInfo: { $set: action.payload },
      });
    }
    case ActionTypes.CLOSE_SIGNATURE_MODAL: {
      return {
        ...state,
        showSignatureModal: false,
      };
    }
    case ActionTypes.CANCEL_SIGNATURE_MODAL: {
      return {
        ...state,
        showSignatureModal: false,
        pendingBlockInfo: undefined,
      };
    }
    case ActionTypes.CONFIRM_SIGNATURE_MODAL: {
      const { signatureSettings } = action.payload;
      return {
        ...state,
        signatureSettings,
        showSignatureModal: false,
        pendingBlockInfo: undefined,
      };
    }
    case ActionTypes.CONFIRM_SIGNATURE_MODAL_DONE: {
      return update(state, {
        getBlockValueFromSettings: { $set: false },
        signatureAccepted: { $set: true },
      });
    }
    case ActionTypes.SIGNER_PHONE_NUMBER_COLLECTED: {
      return update(state, {
        signerPhoneNumber: { $set: action.payload },
      });
    }
    case ActionTypes.TERMS_ACCEPTED: {
      return {
        ...state,
        termsAccepted: true,
      };
    }
    case ActionTypes.SET_PENDING_BLOCK_INFO: {
      return update(state, {
        getBlockValueFromSettings: { $set: true },
        pendingBlockInfo: { $set: action.payload },
      });
    }
    case ActionTypes.SUBMIT_ENVELOPE_DONE: {
      return {
        ...state,
        alreadySigned: true,
      };
    }
    case ActionTypes.SHOW_EXIT_SIGNING_MODAL: {
      return {
        ...state,
        showExitSigningModal: true,
      };
    }
    case ActionTypes.CLOSE_EXIT_SIGNING_MODAL: {
      return {
        ...state,
        showExitSigningModal: false,
      };
    }
    default: {
      return state;
    }
  }
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default modalReducer;
